import { render, staticRenderFns } from "./Maximize.vue?vue&type=template&id=6097fe7c&scoped=true&"
import script from "./Maximize.vue?vue&type=script&lang=js&"
export * from "./Maximize.vue?vue&type=script&lang=js&"
import style0 from "./Maximize.vue?vue&type=style&index=0&id=6097fe7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097fe7c",
  null
  
)

export default component.exports